import { MediaImage } from "../../shared/MediaImage";
import { MultiMediaCardProps } from "../../interface";
import { MultiMediaCardPlaceholder } from "./Placeholder";
import classes from "./multiMediaCard.module.scss";

export const MultiMediaCard = (props: MultiMediaCardProps) => {
    const { id, title, description, image } = props.item;
    if (!id || !image) {
        return <MultiMediaCardPlaceholder />;
    }

    return (
        <div className={classes.card} data-testid="multi-media-card">
            <MediaImage {...props} />
            <p
                className={classes.headline}
                data-testid="multi-media-card-headline"
            >
                {title ?? description}
            </p>
        </div>
    );
};
